import { registerFr } from '../i18n/index.js';

registerFr({
  // ── the stream ──
  'Nothing logged here yet. A meeting, a call, a mail, a note — every touchpoint with provenance becomes a row.':
    'Rien n’est encore consigné ici. Un rendez-vous, un appel, un courriel, une note — chaque contact avec sa provenance devient une ligne.',
  'Date not confirmed': 'Date non confirmée',
  'Mail in': 'Courriel entrant',
  'Mail out': 'Courriel sortant',
  'Meeting': 'Rendez-vous',
  'Call': 'Appel',
  'Note': 'Note',
  'Post': 'Publication',
  'Signal': 'Signal',

  // ── log a touchpoint ──
  'Log a touchpoint': 'Consigner un contact',
  'Kind': 'Type',
  'Date': 'Date',
  'Title': 'Titre',
  'What happened, in a few words': 'Ce qui s’est passé, en quelques mots',
  'Summary': 'Résumé',
  'Organisation': 'Organisation',
  'Search organisations': 'Rechercher des organisations',
  'Participants': 'Participants',
  'Search people, or type a name and add it': 'Rechercher des personnes, ou saisir un nom et l’ajouter',
  'Add "{name}" as a name, not yet a person': 'Ajouter « {name} » comme nom, pas encore une personne',
  'Touchpoint logged.': 'Contact consigné.',
  'Could not save the touchpoint.': 'Impossible d’enregistrer le contact.',
}, 'Timeline');
